import * as React from 'react';
import classnames from 'classnames';

import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

import './tile-standard-overlay.scss';

applyTranslations(require('./tile-standard-overlay.i18n.json'));
applyTranslations(require('../freemium-popover/freemium-popover.i18n.json'));

type Props = {
  size: 'small' | 'normal'
};

const MSG_KEY = 'tile_standard_overlay';

const TileStandardOverlay = ({
  size = 'normal'
}: Props): JSX.Element => {
  const containerClasses = classnames('tile-standard-overlay', {
    [`tile-standard-overlay--size-${size}`]: Boolean(size)
  });

  const buttonClasses = classnames('freemium-popover__button', {
    [`tile-standard-overlay__button--size-${size}`]: Boolean(size)
  });

  return (
    <div className={containerClasses}>
      <div className="tile-standard-overlay__message">
        {__t(`${MSG_KEY}.message`)}
      </div>
      <div className="tile-standard-overlay__button">
        <ActionButton
          color="primary"
          className={buttonClasses}
          customSize={{ width: size === 'small' ? 230 : 274 }}
          link={__t('freemium_popover.email')}
        >
          {__t(`${MSG_KEY}.button`)}
        </ActionButton>
      </div>
    </div>
  );
};

export default TileStandardOverlay;
